
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { NgxUiLoaderModule, NgxUiLoaderRouterModule } from 'ngx-ui-loader';
import { Angulartics2Module } from 'angulartics2';
import { UiSwitchModule } from 'ngx-ui-switch';
import { AccountService } from './core/services/Common/account.service';
import { AccountEndpoint } from './core/endpoints/account-endpoint.service';
import { ConfirmDialogComponent } from './confirm-dialog.component';
import { DxButtonModule, DxPopupModule,   DxTemplateModule, DxToastModule } from 'devextreme-angular';
import { DxTabPanelModule } from 'devextreme-angular/ui/tab-panel';
import { AuthService } from './core/services';


@NgModule({
  declarations: [
    AppComponent,ConfirmDialogComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule,
    CoreModule,
    NgxUiLoaderModule,
    NgxUiLoaderRouterModule,
    UiSwitchModule,
    DxToastModule,
    DxPopupModule,
    DxButtonModule,
    DxTabPanelModule,
    DxTemplateModule
    // import NgxUiLoaderRouterModule. By default, it will show foreground loader.
    // NgxUiLoaderRouterModule.forRoot({ showForeground: false }) // If you need to show background spinner
    // added to imports
    //Angulartics2Module.forRoot()
  ],
  providers: [AccountService, AccountEndpoint , AuthService],
  bootstrap: [AppComponent]
})
export class AppModule { }
